import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { CapturumAccordionCardComponent } from '@capturum/ui/accordion';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'cpb-collapsable-wrapper',
  templateUrl: './collapsable-wrapper.component.html',
  styleUrls: ['./collapsable-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CapturumBuilderCollapsableWrapperComponent extends FieldWrapper {
  @ViewChild('accordionCard')
  public accordionCard: CapturumAccordionCardComponent;
  public clickable: boolean = true;

  public toggleCard(): void {
    this.accordionCard.toggleCard(this.clickable);
  }
}
